/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Card, Row, Col, message, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import {
    TableComponent
} from "../../../CommonComponents";
import "../../styles.scss";
import Heading from "../../../../../components/Heading";
import { useRequestCancellation } from "../../../../../hooks/useRequestCancellation";
import { useNavigate, useLocation } from "react-router-dom";
import { showErrorMessage } from "../../../../../utils";

const HubOutscanVsCpInscanClickableA3 = () => {
    // Global request cancellation hook
    const { createNewRequest, isLatestRequest } = useRequestCancellation();

    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
    });
    const [reportData, setReportData] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();
    const navigationState = location.state || {};
    const { fromDate_date, toDate_date, type } = navigationState;
    const from_hub_id = navigationState.from_hub_id || navigationState.fromHubId || navigationState.hubId;
    const cp_id = navigationState.cp_id || navigationState.cpId || navigationState.toCpId;

    // Fetch report data
    const fetchReport = async () => {
        const requestId = createNewRequest();
        setLoading(true);
        let shouldUpdateState = true;

        try {
            // Get form parameters from state extracted above

            if (!fromDate_date || !toDate_date) {
                setLoading(false);
                return;
            }

            setReportData([]);

            const queryParams = new URLSearchParams({
                fromDate_date: fromDate_date,
                toDate_date: toDate_date,
                page: pagination.current,
                size: pagination.pageSize
            });

            if (from_hub_id != null) queryParams.append("from_hub_id", from_hub_id);
            if (cp_id != null) queryParams.append("cp_id", cp_id);

            let dynamicUrl = "";
            let bearerToken = "db63076deeb5a4f515b75959e7a66a23509dc0b3a56ee6b628008e01a473582c"; // Default token

            switch (type) {
                case "outscanByHubToCp":
                    dynamicUrl = "t4_clickable_hoci_outscan_to_cp_de_d43e52";
                    bearerToken = "db63076deeb5a4f515b75959e7a66a23509dc0b3a56ee6b628008e01a473582c";
                    break;
                case "inscanBySameCp":
                    dynamicUrl = "t4_clickable_hoci_inscan_by_same_cp_de_d43e52";
                    bearerToken = "23edcfee9b527258313f9a7c816f99a8022d3a1c5880ad520d7d349dd876e87a";
                    break;
                case "inscanByOtherCp":
                    dynamicUrl = "t4_clickable_hoci_inscan_by_other_cp_de_d43e52";
                    bearerToken = "0539d89465e13f46860161dea5ff419e8808a3784d2549382e5a7b3e3e9f9f27";
                    break;
                default:
                    dynamicUrl = "t4_clickable_hoci_outscan_to_cp_de_d43e52";
            }

            const url = `https://a3-framework.prayog.io/dynamic/${dynamicUrl}?${queryParams.toString()}`;

            const user = JSON.parse(localStorage.getItem("userinfo") || "{}");
            const body = {
                "user_name": user?.userName || "shriraj_bhosale",
                "user_email": user?.userEmail || "shriraj.bhosale@shreemaruti.com"
            };

            const fetchResponse = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${bearerToken}`
                },
                body: JSON.stringify(body),
            });

            const responseData = await fetchResponse.json();

            // 🔥 Check if this is still the latest request
            if (!isLatestRequest(requestId.requestId)) {
                shouldUpdateState = false;
            } else {
                if (fetchResponse.ok) {
                    const data = responseData?.data || [];
                    const count = responseData?.total_records || (Array.isArray(data) ? data.length : 0);
                    setReportData(data);
                    setPagination(prev => ({
                        ...prev,
                        total: count,
                    }));
                } else {
                    throw new Error(responseData?.message || "Failed to fetch report data");
                }
            }
        } catch (error) {
            console.error("fetchReport error:", error);
            if (shouldUpdateState && isLatestRequest(requestId.requestId)) {
                showErrorMessage(error?.message || "Failed to fetch report data");
                setReportData([]);
                setPagination(prev => ({
                    ...prev,
                    total: 0
                }));
            }
        } finally {
            if (shouldUpdateState && isLatestRequest(requestId.requestId)) {
                setLoading(false);
            }
        }
    };

    // Fetch report data
    useEffect(() => {
        if (!location.state) return;
        fetchReport();
        // eslint-disable-next-line
    }, [location.state, pagination.current, pagination.pageSize]);

    const handleTableChange = (paginationInfo) => {
        setPagination(prev => ({
            ...prev,
            current: paginationInfo.current,
            pageSize: paginationInfo.pageSize
        }));
    };

    const handleDownload = async () => {
        // Since there's no download URL provided for this A3 clickable report in the curl,
        // we might not be able to implement it yet unless we guess the URL pattern.
        // Usually it's /download at the end.
        message.info("Download functionality not implemented for A3 clickable report");
    };

    const handleBack = () => {
        navigate("/hub-outscan-vs-cp-inscan-report-a3");
    };

    const getTableColumns = () => {
        return [
            {
                title: "AWB Number",
                dataIndex: "awb_number",
                key: "awb_number",
                sorter: true,
                width: 150,
                render: (text) => (
                    <span
                        style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => {
                            if (text) {
                                const url = `/shipment-tracker?awb=${text}`;
                                window.open(url, "_blank");
                            }
                        }}
                    >
                        {text || "-"}
                    </span>
                )
            },
            {
                title: "Date",
                dataIndex: "date",
                key: "date",
                sorter: true,
                width: 140,
                render: (text, record) => text || record.date_time || record.datetime || "-"
            },
            {
                title: "From Hub",
                dataIndex: "from_hub",
                key: "from_hub",
                sorter: true,
                width: 150,
            },
            {
                title: "To CP",
                dataIndex: "cp_name",
                key: "cp_name",
                sorter: true,
                width: 150,
            },
            {
                title: "Weight (Kg)",
                dataIndex: "weight",
                key: "weight",
                width: 100,
                render: (text, record) => {
                    const weightVal = text || record.total_outscan_weight || record.applied_weight;
                    return weightVal ? Number(weightVal).toFixed(2) : "0.00";
                }
            }
        ];
    };

    const getReportTitle = () => {
        switch (type) {
            case "outscanByHubToCp": return "Outscan By Hub To CP Report (A3)";
            case "inscanBySameCp": return "Inscan By Same CP Report (A3)";
            case "inscanByOtherCp": return "Inscan By Other CP Report (A3)";
            default: return "Report Details (A3)";
        }
    };

    return (
        <div className="report-container">
            <div style={{ backgroundColor: "white", padding: "8px 16px", borderRadius: "8px" }}>
                <Heading
                    title={getReportTitle()}
                    navigateTo="/hub-outscan-vs-cp-inscan-report-a3"
                    showBackButton={true}
                    onBackClick={handleBack}
                />
            </div>
            <TableComponent
                columns={getTableColumns()}
                dataSource={reportData}
                loading={loading}
                pagination={pagination}
                onChange={handleTableChange}
                rowKey={(record, index) => record.awb_number || record.id || index}
                style={{ marginTop: 32 }}
            />
        </div>
    );
};

export default HubOutscanVsCpInscanClickableA3;
